export default __webpack_public_path__ + "assets/quick-service.a41590b8.svg";